module.exports = __webpack_public_path__ + "media/images/icon-favorite-d6864246709dcf62c0c335f4bae2a8bd.svg";